import Component from '../lib/Component'
import gsap, { Expo, Power1, Power4 } from 'gsap'
import SplitText from 'gsap/SplitText'

export default class Animations extends Component {
	static selector = '[data-animations]'

	initialize() {
		this.createSplitText()
		this.createFade()
		this.createFadeInScroll()
		this.createFadeInYScroll()
		this.createZoomOut()
		this.createZoomIn()
		this.createSlideX()
		this.createZoomScroll()
		this.createCounter()
		this.createFadeInRandom()
		this.createLineDraw()
	}

	createSplitText() {
		const text = this.$$('[data-anim="textSplit"]')
		if (text.length > 0) {
			this.textSplit = new SplitText(text, {
				type: 'lines',
				linesClass: 'js-text-line',
			})

			this.textSplitWrapper = new SplitText(text, {
				type: 'lines',
				linesClass: 'js-text-line-wrapper',
			})

			gsap.set(text, { opacity: 1 })

			gsap.from(this.textSplit.lines, {
				yPercent: 200,
				rotate: 15,
				opacity: 0,
				duration: 1.2,
				ease: 'Expo.easeOut',
				stagger: 0.075,
				clearProps: 'all',
				scrollTrigger: {
					trigger: this.$el,
					start: 'top 65%',
					scrub: false,
				},
			})
		}
	}

	createFade() {
		const elements = this.$$('[data-anim="fade"]')
		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					opacity: 0,
				},
				{
					ease: Power4.easeOut,
					opacity: 1,
					duration: 1,
				},
			)
		}
	}

	createFadeInScroll() {
		const elements = this.$$('[data-anim="fadeIn"]')
		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					opacity: 0,
				},
				{
					opacity: 1,
					stagger: 0.1,
					duration: 1.8,
					delay: 0.8,
					ease: Power4.easeOut,
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						scrub: false,
					},
				},
			)
		}
	}

	createFadeInYScroll() {
		const elements = this.$$('[data-anim="fadeInY"]')
		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					opacity: 0,
					y: 10,
				},
				{
					opacity: 1,
					y: 0,
					stagger: 0.1,
					ease: Power4.easeOut,
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						scrub: false,
					},
				},
			)
		}
	}

	createZoomOut() {
		const elements = this.$$('[data-anim="zoomOut"]')

		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					transformOrigin: '50% 50%',
					scale: 1.1,
					opacity: 0,
				},
				{
					opacity: 1,
					scale: 1,
					stagger: 0.1,
					duration: 1.8,
					ease: Power4.easeOut,
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						scrub: false,
					},
				},
			)
		}
	}

	createZoomIn() {
		const elements = this.$$('[data-anim="zoomIn"]')

		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					transformOrigin: '50% 50%',
					scale: 0.9,
					opacity: 0,
				},
				{
					opacity: 1,
					scale: 1,
					delay: 0.5,
					stagger: 0.1,
					duration: 1.8,
					ease: Expo.easeOut,
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						scrub: false,
					},
				},
			)
		}
	}

	createFadeInRandom() {
		const elements = this.$$('[data-anim="fadeInRandom"]')
		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					opacity: 0,
				},
				{
					opacity: 1,
					stagger: {
						amount: 0.4,
						from: 'random',
					},
					duration: 2,
					ease: Power4.easeOut,
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						scrub: false,
					},
				},
			)
		}
	}

	// Scroll Scrub  effects
	createSlideX() {
		const elements = this.$$('[data-anim="slideX"]')
		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					opacity: 0,
					x: -50,
				},
				{
					opacity: 1,
					x: 0,
					delay: 0.8,
					stagger: 0.1,
					duration: 1,
					ease: Expo.easeOut,
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						scrub: false,
					},
				},
			)
		}
	}

	createZoomScroll() {
		const elements = this.$$('[data-anim="zoomScroll"]')
		if (elements.length > 0) {
			gsap.fromTo(
				elements,
				{
					transformOrigin: '50% 50%',
					transformPerspective: '1000',
					z: 0,
				},
				{
					z: 200,
					stagger: 0.05,
					duration: 2,
					ease: Power1.easeOut,
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						end: '+=200%',
						scrub: true,
					},
				},
			)
		}
	}

	createCounter() {
		const elements = this.$$('[data-counter]')
		if (elements.length > 0) {
			elements.forEach((element) => {
				const counter = { val: 0 }
				const value = element.dataset.counter
				gsap.to(counter, {
					val: value,
					duration: 2,
					stagger: 2,
					ease: Power4.easeOut,
					roundProps: 'val',
					onUpdate: function () {
						element.innerHTML = counter.val
					},
					scrollTrigger: {
						trigger: this.$el,
						start: 'top center',
						scrub: false,
					},
				})
			})
		}
	}

	createLineDraw() {
		const elements = this.$$('[data-anim="lineDraw"]')
		if (elements.length > 0) {
			gsap.set(elements, { opacity: 1 })

			gsap.fromTo(
				elements,
				{
					transformOrigin: '0 0',
					rotateY: 90,
				},
				{
					opacity: 1,
					stagger: 0.05,
					rotateY: 0,
					duration: 1,
					delay: 0.5,
					ease: 'power0.none',
					scrollTrigger: {
						trigger: this.$el,
						start: 'top 65%',
						scrub: false,
					},
				},
			)
		}
	}
}
